import { render, staticRenderFns } from "./AppPubNews.vue?vue&type=template&id=042b4a92&"
import script from "./AppPubNews.vue?vue&type=script&lang=js&"
export * from "./AppPubNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports